import React, { FC, ReactElement, useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import Application from 'src/front/components//Application';
import QuickLinks from 'src/front/components//QuickLinks';
import { StepperRefProps } from 'src/front/components//StepperView';
import TransferHistoryProvider from 'src/front/contexts/TransferHistoryContext';
import AccountSelection from './AccountSelection';
import ViewHistory from './ViewHistory';

const MoneyTransferHistory: FC = () => {
  const { t } = useTranslation();
  const stepperRef = useRef<StepperRefProps>(null);

  const goToNextStep = async (): Promise<void> => {
    stepperRef.current?.goToNextStep();
  };
  const steps = [
    {
      component: () => <AccountSelection goToNextStep={goToNextStep} />,
    },
    {
      component: () => <ViewHistory />,
    },
  ];
  const stepsVertical = useMemo(() => {
    const stepDefinitions = [
      {
        text: t('callCenter_internetBanking_stepper_accountSelection_text'),
      },
      {
        text: t('callCenter_internetBanking_stepper_viewHistory_text'),
      },
    ];
    return stepDefinitions.map((item, index) => ({
      text: item.text,
      index: index + 1,
    }));
  }, [t]);
  return (
    <Application stepperRef={stepperRef} steps={steps} stepsVertical={stepsVertical} isCompleted />
  );
};
export default (): ReactElement => (
  <TransferHistoryProvider>
    <QuickLinks />
    <MoneyTransferHistory />
  </TransferHistoryProvider>
);
